import { Component, DoCheck, OnInit, ViewEncapsulation } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AppSettings } from '../../models/app.settings';
import { Settings } from '../../models/app.settings.model';
import { MenuService } from '../menu/menu.service';
import { LoginResult, TokenData } from '../../models';
import { JwtHelperService } from '@auth0/angular-jwt';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../services';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SidenavComponent implements OnInit, DoCheck {
  public psConfig: PerfectScrollbarConfigInterface = {
    wheelPropagation: true,
  };
  public menuItems: Array<any>;
  public settings: Settings;
  tokenData: TokenData = {};

  constructor(
    public appSettings: AppSettings,
    public menuService: MenuService,
    private jwtHelper: JwtHelperService,
    private translateService: TranslateService,
    private authenticationService: AuthenticationService
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    this.menuItems = this.menuService.getVerticalMenuItems();
    const token = this.jwtHelper.tokenGetter();
    this.tokenData = this.jwtHelper.decodeToken(token);
    const userData = JSON.parse(localStorage.getItem('user_data')) as LoginResult;
    this.tokenData.user_name = userData.setting.personName;
    if (this.authenticationService.hasPermission(['Provider'])) {
      this.setProviderDisplayName(userData);
      this.translateService.onLangChange.subscribe(() => {
        this.setProviderDisplayName(userData);
      });
    }
  }

  private setProviderDisplayName(userData: LoginResult): void {
    this.tokenData.user_name =
      this.settings.language === 'ar'
        ? userData.setting.personNameAr
        : userData.setting.personNameEn;
  }

  ngDoCheck() {
    if (this.settings.fixedSidenav) {
      if (this.psConfig.wheelPropagation === true) {
        this.psConfig.wheelPropagation = false;
      }
    } else {
      if (this.psConfig.wheelPropagation === false) {
        this.psConfig.wheelPropagation = true;
      }
    }
  }

  public closeSubMenus() {
    const menu = document.getElementById('vertical-menu');
    if (menu) {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < menu.children[0].children.length; i++) {
        const child = menu.children[0].children[i];
        if (child) {
          if (child.children[0].classList.contains('expanded')) {
            child.children[0].classList.remove('expanded');
            child.children[1].classList.remove('show');
          }
        }
      }
    }
  }
}
